import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTriangleBottom = props => (
  <SvgIcon {...props} viewBox="0 0 10 5">
    <path d="m0 0 5 5 5-5h-10z" />
  </SvgIcon>
);

export default IconTriangleBottom;



// WEBPACK FOOTER //
// ./src/components/icons/IconTriangleBottom.js